var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmStepDoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_240_621",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 46,
    height: 46
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 45.8334C27.7364 45.837 30.4465 45.2997 32.9746 44.2525C35.5027 43.2053 37.7989 41.6688 39.7313 39.7313C41.6687 37.799 43.2052 35.5028 44.2524 32.9747C45.2996 30.4466 45.8369 27.7365 45.8333 25.0001C45.8368 22.2637 45.2995 19.5536 44.2523 17.0255C43.2051 14.4975 41.6687 12.2013 39.7313 10.2688C37.7989 8.33138 35.5027 6.79489 32.9746 5.74769C30.4465 4.70049 27.7364 4.16322 25 4.16677C22.2636 4.16328 19.5535 4.70057 17.0255 5.74777C14.4974 6.79497 12.2012 8.33142 10.2688 10.2688C8.33133 12.2013 6.79487 14.4975 5.74768 17.0255C4.70048 19.5536 4.16319 22.2637 4.16667 25.0001C4.16313 27.7365 4.7004 30.4466 5.7476 32.9747C6.7948 35.5028 8.33129 37.799 10.2688 39.7313C12.2012 41.6688 14.4974 43.2052 17.0255 44.2524C19.5535 45.2996 22.2636 45.8369 25 45.8334Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 25L22.9167 31.25L35.4167 18.75",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_240_621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H50V50H0V0Z",
    fill: "#4BDD82"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmStepDoneIcon);
export default __webpack_public_path__ + "static/media/confirm-step-done-icon.32ce1632dd9e0a3c2289136d42231b95.svg";
export { ForwardRef as ReactComponent };